// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorFault {
  LowerPitSwitch = 0,
  PowerLoss = 1,
  UpperCombImpact = 2,
  Overspeed = 3,
  DoorDoesNotClose = 4,
  StartPermitRelay = 5,
  Overload = 6,
  Drive = 7,
  EmergencyPower = 8,
  Earthquake = 9,
  DoorTimedOutClosing = 10,
  CarNotAvailable = 11,
  DriveNotAvailable = 12,
  DoorTimedOutOpening = 13,
  HallButtonFailureBussFuseBlown = 14,
  CarDelayedExessively = 15,
  DoorOpenAndDoorLockConcurrently = 16,
  OutOfServiceWithDoorLock = 17,
  OutOfServiceWithoutDoorLock = 18,
  LostDoorLockWhileRunning = 19,
  PhotoCellDectector = 20,
  SafetyEdgeFailure = 21,
  HoistwaySafetyCircuitOpen = 22,
  GovernorSwitchOpen = 23,
  CarSafetyCircuitOpen = 24,
  CarTopSwitchOpen = 25,
  CommunicationLoss = 26,
  Reset = 27,
  Position = 28,
  BinaryInput = 29,
  DoorZone = 30,
  Stalled = 31,
  DoorOpen = 32,
  DoorClose = 33,
  Up = 34,
  Down = 35,
  HoistwayLearn = 36,
  StopSwitch = 37,
  DPRInput = 38,
  LcFuseBlown = 39,
  HcFuseBlown = 40,
  PositionInputOff = 41,
  CarSafety = 42,
  UlOrDlOff = 43,
  DeltaOff = 44,
  UtCount = 45,
  Ut1Count = 46,
  Ut2Count = 47,
  Ut3Count = 48,
  DtCount = 49,
  Dt1Count = 50,
  Dt2Count = 51,
  Dt3Count = 52,
  RearDoorOpen = 53,
  RearDoorClose = 54,
  Car1CommLoss = 55,
  Car2CommLoss = 56,
  Car3CommLoss = 57,
  Car4CommLos = 58,
  Car5CommLoss = 59,
  Car6CommLoss = 60,
  RunIoFailedOn = 61,
  RunORunA_I = 62,
  RunIoFailedOff = 63,
  RunAIoFailedOn = 64,
  RunAIoFailedOff = 65,
  UpIoFailedOn = 66,
  UpIoFailedOff = 67,
  DnrIoFailedOn = 68,
  DnrIoFailedOff = 69,
  UpfIoFailedOn = 70,
  UpfIoFailedOff = 71,
  DfIoFailedOn = 72,
  DfIoFailedOff = 73,
  MsIoFailedOn = 74,
  Run0Run1Failed = 75,
  MsIoFailedOff = 76,
  McIoFailedOn = 77,
  McIoFailedOff = 78,
  BrkIoFailedOn = 79,
  BrkIoFailedOff = 80,
  DonIoFailedOff = 81,
  RunA = 82,
  TopDoorLock = 83,
  MidDoorLock = 84,
  BotDoorLock = 85,
  GateSwitch = 86,
  RearTopLock = 87,
  RearMidLock = 88,
  RearBotLock = 89,
  RearGateSwitch = 90,
  PInputOff = 91,
  EmergencyStop = 92,
  InspectionInput = 93,
  GateLockBypassSwitch = 94,
  Grt1InputOn = 95,
  Grt1InputOff = 96,
  Grt2InputOn = 97,
  Grt2InputOff = 98,
  GripperDidNotPick = 99,
  GripperTrip = 100,
  DlTopAndDlTop1Opposite = 101,
  DlMidAndDlMid1Opposite = 102,
  DlBotAndDlBot1Opposite = 103,
  GateSwitchAndGateSwitch1Opposite = 104,
  RlmAndRlm1Opposite = 105,
  RgsAndRgs1Opposite = 106,
  BrakePick = 107,
  BrakeDrop = 108,
  BrakeSetGripper = 109,
  DeltaOn = 110,
  CwtSwitchErrorAtDT = 111,
  CwtSwitchErrorAtUT = 112,
  TargetAtUT = 113,
  TargetAtUT1 = 114,
  TargetAtUT2 = 115,
  TargetAtUt3 = 116,
  TargetAtDT = 117,
  TargetAtDT1 = 118,
  TargetAtDT2 = 119,
  TargetAtDT3 = 120,
  HcComDevice = 121,
  CarComDevice = 122,
  TocCANComm = 123,
  DriveComRecv = 124,
  PowerUpReset = 125,
  PossibleDrv1028Er = 126,
  CarSafePreop = 127,
  CarSafeStart = 128,
  InspectionUpDnSwitch = 129,
  DriveComTrmError = 130,
  DriveComIntError = 131,
  DriveComTxEmptyEr = 132,
  UTSCount = 133,
  DTSCount = 134,
  TargetAtUTS = 135,
  TargetAtDTS = 136,
  DriveCom8259 = 137,
  DriveComTxStopEr = 138,
  SpbCANCom = 139,
  DbrTemperature = 140,
  SebCANCom = 141,
  LwCalibration = 142,
  CANChipInit = 143,
  RunShutdown = 144,
  BadFloorTable = 145,
  CarGateOpen = 146,
  ContactorDropTimer = 147,
  GateLock = 148,
  DerailmentDoorOpen = 149,
  DownDirectionalSwitch = 150,
  NoBalanceComplete = 151,
  CanNotDetermineMode = 152,
  NoRetriesLeft = 153,
  SequenceTimers = 154,
  HoistwaySafetyString = 155,
  SafetyStringOpen = 156,
  UpDirectionalSwitch = 157,
  VelocityNotZero = 158,
  TopNetFeedback = 159,
  BottomNetFeedback = 160,
  DriveSerialLink = 161,
  BrakeFeedbackContact = 162,
  FrontDoorObstruction = 163,
  RearDoorObstruction = 164,
  FrontPhotocell = 165,
  RearPhotocell = 166,
  TimedOutOfService = 167,
  PositionNotKnown = 168,
  DriveShutdown = 169,
  DoorSafetyOpen = 170,
  EmergencyStopOpen = 171,
  SerialNTSError = 172,
  InitFailure = 173,
  CounterWeightDerailed = 174,
  StartProtect = 175,
  Brake = 176,
  Motion = 177,
  FrontDoorFailedToOpenClose = 178,
  RearDoorFailedToOpenClose = 179,
  CarCommunicationLoss = 180,
  NoCommWithMapOrGroup = 181,
  ServiceProtect = 182,
  ShuntTrip = 183,
  EmergencyDispatch = 184,
  UnintendedMotion = 185,
  RescueOperations = 186,
  RunMonitorFailure = 187,
  Selector = 188,
  FrontHoistDoorWatchdog = 189,
  RearHoistDoorWaatchdog = 190,
  FrontCarDoorWatchdog = 191,
  RearCarDoorWatchdog = 192,
  DiagnosticsCarLockout = 193,
  LowOil = 194,
  Viscosity = 195,
  LoadweigherShutdown = 196,
  CheckedRedundancyShutdown = 197,
  RetiringCamFailure = 198,
  FrontDoorCommLoss = 199,
  RearDoorCommLoss = 200,
  InvalidInspection = 201,
  FloodedPit = 202,
  AttemptedOverspeed = 203,
  B2ContactorOpen = 204,
  BContactorFailed = 205,
  BContactorOpen = 206,
  BelowBottonDZ = 207,
  BothuetAndDets = 208,
  CPUStopSwitch = 209,
  Car7CommLos = 210,
  Car8CommLoss = 211,
  CarBypassSwitch = 212,
  CarLost = 213,
  CarNetwork = 214,
  CheckGSW = 215,
  CheckInterlock = 216,
  ContactorNotClosed = 217,
  CorrectionRun = 218,
  DriveConfiguration = 219,
  DriveNotReady = 220,
  ETSOverspeed = 221,
  ErrorClosingsMRelay = 222,
  ErrorOpoeningsMRelay = 223,
  FaultLogAutoClear = 224,
  FaultsCleared = 225,
  GroupNetwork = 226,
  HallBypassSwitch = 227,
  HallCallNodeError = 228,
  HighSpeedTest = 229,
  InCarStop = 230,
  InvalidContractSpeed = 231,
  InvalidHighSpeed = 232,
  InvalidInspectionSpeed = 233,
  LearnError = 234,
  LostDCL = 235,
  LostGateSwitchOutsideDZ = 236,
  LostSaf = 237,
  LowPressure = 238,
  MContactorFailed = 239,
  MContactorOpen = 240,
  MotorNotUpToSpeed = 241,
  MotorStopFailed = 242,
  MotorTimerLimit = 243,
  OutOfService = 244,
  RedudantAccess = 245,
  RedudantCarBypass = 246,
  RedundanTuets = 247,
  RedundantBottomLock = 248,
  RedundantDets = 249,
  RedundantFireStop = 250,
  RedundantGateSwitch = 251,
  RedundantHallBypass = 252,
  RedundantICStop = 253,
  RedundantInspection = 254,
  RedundantInspic = 255,
  RedundantMiddleLock = 256,
  RedundantRearGateSwitch = 257,
  RedundantTopLock = 258,
  Saf1CloseFailure = 259,
  Saf1OpenFail = 260,
  Saf2CloseFailure = 261,
  Saf2OpenFail = 262,
  SafetyConfiguration = 263,
  SavedConfiguration = 264,
  SpeedDeviationError = 265,
  SpineTCT = 266,
  SpineTMR = 267,
  TedundantInsPmr = 268,
  Earthquake2 = 269,
  CommunicationLossToGroup = 270,
  InitializationShutdown = 271,
  GovernorOpen = 272,
  SafetyHStringOpen = 273,
  FrontPhotoEyeFailure = 274,
  RearPhotoEyeFailure = 275,
  LandingSystemSensorFault = 276,
  MotorContactorProofingFault = 277,
  UpDirectionLimitOpen = 278,
  DroFault = 279,
  BrakeEnableFault = 280,
  BrakeCurrentNotOffFault = 281,
  InsufficientBrakeCurrentFeedback = 282,
  BrakeVoltageNotOnFault = 283,
  BrakeIgbtFault = 284,
  BrakeModuleOverTemperatureFault = 285,
  HeatSensorFault2 = 286,
  HeatSensorFault3 = 287,
  HeatSensorFault4 = 288,
  PowerSupplyFault1 = 289,
  PowerSupplyFault2 = 290,
  PowerSupplyFault3 = 291,
  PowerSupplyFault4 = 292,
  DriveAtSpeedFault = 293,
  FrontDoorCloseTimeout = 294,
  FrontDoorOpenTimeout = 295,
  RearDoorCloseTimeout = 296,
  RearDoorOpenTimeout = 297,
  MainFireServiceRecall = 298,
  AltFireServiceRecall = 299,
  InCarFiremanService = 300,
  ElevatorRecallSwitch1 = 301,
  ElevatorRecallSwitch2 = 302,
  ElevatorRecallSwitch3 = 303,
  ElevatorRecallSwitch4 = 304,
  ElevatorRecallSwitch5 = 305,
  ElevatorRecallSwitch6 = 306,
  FrontDoorContactMonitoringFault = 307,
  RearDoorContactMonitoringFault = 308,
  FrontSafeEdgeFailure = 309,
  RearSafeEdgeFailure = 310,
  InCarInspectionOperation = 311,
  HoistwayAccessOperation = 312,
  TestMode = 313,
  CaptureMode = 314,
  IndependentService = 315,
  HospitalEmergencyService = 316,
  InCarHospitalEmergencyService = 317,
  AttendantService = 318,
  PassengerOperation = 319,
  PositionFaultUnt1 = 320,
  PositionFaultUnt2 = 321,
  PositionFaultUnt3 = 322,
  PositionFaultUnt4 = 323,
  PositionFaultUnt5 = 324,
  PositionFaultUets = 325,
  PositionFaultDnt1 = 326,
  PositionFaultDnt2 = 327,
  PositionFaultDnt3 = 328,
  PositionFaultDnt4 = 329,
  PositionFaultDnt5 = 330,
  PositionFaultDets = 331,
  PositionQuadratureFailure = 332,
  QuadratureSpeedThresholdFault = 333,
  QuadratureSpeedDeviationFault = 334,
  MotionStartFailure = 335,
  InvalidLogicalIndicatorAccess = 336,
  EmergencyPowerNoSupervisorShutdown = 337,
  EmergencyPowerNoSupervisorDeactivated = 338,
  CarDelayedDoorsOpen = 339,
  CarOutOfServiceDoorsOpen = 340,
  CarOutOfServiceDoorsClosed = 341,
  EarthquakeBoardPowerOn = 342,
  EarthquakeBoardPowerOff = 343,
  EarthquakeResetButtonStuck = 344,
  EarthquakeResetButtonOk = 345,
  FireServicePhaseIIHold = 346,
  FireServicePhaseIIRecall = 347,
  LoadLearnActivated = 348,
  LoadLearnDeactivated = 349,
  CarHeavyLoad = 350,
  FireServiceRecallDeactivated = 351,
  InCarFiremanServiceDeactivated = 352,
  CarLightLoad = 353,
  CarDispatchLoad = 354,
  CarHeavyLoadHallCallsBypassed = 355,
  CarHeavyLoadDeactivated = 356,
  CarHeavyLoadActivated = 357,
  CarOverloadDeactivated = 358,
  PhotoEyeAntinuisance = 359,
  LightLoadAntinuisance = 360,
  NudgingOperation = 361,
  FrontPhotoEyeBypassed = 362,
  RearPhotoEyeBypassed = 363,
  FrontSafeEdgeBypassed = 364,
  RearSafeEdgeBypassed = 365,
  RecallSwitch1Deactivated = 366,
  RecallSwitch2Deactivated = 367,
  RecallSwitch3Deactivated = 368,
  RecallSwitch4Deactivated = 369,
  RecallSwitch5Deactivated = 370,
  RecallSwitch6Deactivated = 371,
  InspectionOverspeedFault = 372,
  TachErrorFault = 373,
  DriveEnableFeedbackFault = 374,
  SpaIosFault = 375,
  IoMapCompareFault = 376,
  IoMapToggleCompareFault = 377,
  FaultBypassSwitchTimeout = 378,
  SafetyBypassJumperTimeout = 379,
  LearnSwitchTimeout = 380,
  DeviceSpaSibFault = 381,
  DeviceSpbSibFault = 382,
  DeviceQpramFault = 383,
  DeviceEepromFault = 384,
  FrontDoorOpenButtonBypassed = 385,
  RearDoorOpenButtonBypassed = 386,
  FrontDoorOpenButtonFailure = 387,
  RearDoorOpenButtonFailure = 388,
  DoorLockClippedAbove200Fpm = 389,
  SafetyOpened = 390,
  MotionStopIoToggleTest = 391,
  IoMapCompareAlert = 392,
  SpaCosFault = 393,
  SpaLosFault = 394,
  VectorChecksumFault = 395,
  ConfigChecksumFault = 396,
  LimitSwitchesChecksumFault = 397,
  ConfigVectorCrossCheckFault = 398,
  VectorLearnFault = 399,
  LimitSwitchesLearnFault = 400,
  DualChannelQuadFault = 401,
  SingleChannelQuadFault = 402,
  PositionSpeedIndicatorFault = 403,
  VectorComparisonFault = 404,
  VectorCreationFault = 405,
  PositionQuadratureReversedFault = 406,
  Dnt1Level1Fault = 407,
  Dnt2Level1Fault = 408,
  Dnt3Level1Fault = 409,
  Dnt4Level1Fault = 410,
  Dnt5Level1Fault = 411,
  Dnt1Level2Fault = 412,
  Dnt2Level2Fault = 413,
  Dnt3Level2Fault = 414,
  Dnt4Level2Fault = 415,
  Dnt5Level2Fault = 416,
  Unt1Level1Fault = 417,
  Unt2Level1Fault = 418,
  Unt3Level1Fault = 419,
  Unt4Level1Fault = 420,
  Unt5Level1Fault = 421,
  Unt1Level2Fault = 422,
  Unt2Level2Fault = 423,
  Unt3Level2Fault = 424,
  Unt4Level2Fault = 425,
  Unt5Level2Fault = 426,
  SpaDetsLevel2Fault = 427,
  SpaUetsLevel2Fault = 428,
  ExcessiveFaultShutdown = 429,
  AscendingCarOverspeedFault = 430,
  PositionSyncRequiredAtTerminal = 431,
  PositionSyncedAtTerminal = 432,
  PositionSyncRequiredAtFloor = 433,
  PositionSyncedAtFloor = 434,
  CartopCommFault = 435,
  CartopInspectionUnintendedMotionFault = 436,
  CartopAutomaticUnintendedMotionFault = 437,
  SpbFaultBypassSwitchTimeout = 438,
  SpbSafetyBypassJumperTimeout = 439,
  IoMapCompareLongTermAlert = 440,
  IoMapCompareLongTermFault = 441,
  PositionLocationErrorFault = 442,
  PositionCartopOffsetFault = 443,
  CnpmdFault = 444,
  CnpbdFault = 445,
  CnpbFault = 446,
  SpbUetsLevel2Fault = 447,
  SpbDetsLevel2Fault = 448,
  SpbIosFault = 449,
  SpbLosFault = 450,
  SpbCosFault = 451,
  ExcessiveRelevelsFault = 452,
  ExcessiveRestartsFault = 453,
  CartopEmergencyStop = 454,
  CartopPowerLoss = 455,
  DownDirectionLimitOpen = 456,
  FloorLocationFault = 457,
  FloorSensorFault = 458,
  PowerTransferActivated = 459,
  PowerTransferDeactivated = 460,
  InvalidFrontDoorPosition = 461,
  InvalidRearDoorPosition = 462,
  CartopInspectionOperation = 463,
  CarPanelInspectionOperation = 464,
  HoistwayAccessInspectionOperation = 465,
  MachineRoomInspectionOperation = 466,
  InspectionOperation = 467,
  CartopInspectionConstructionOperation = 468,
  CarPanelInspectionConstructionOperation = 469,
  HoistwayAccessInspectionConstructionOperation = 470,
  MachineRoomInspectionConstructionOperation = 471,
  InspectionConstructionOperation = 472,
  DoorLockClippedBelow200Fpm = 473,
  InvalidInput = 474,
  EmsMedicalRecallSwitch1 = 475,
  EmsMedicalInCarSwitch1 = 476,
  EmsMedicalDeactivated = 477,
  EmsMedicalBypassed = 478,
  ScrPowerSupplyFault = 479,
  ScrAcPhaseFault = 480,
  ScrContactorFuseFault = 481,
  ScrPllFault = 482,
  ScrPllWarning = 483,
  ScrDynamicBrakeFault = 484,
  ScrInstantaneousOverCurrent = 485,
  ScrArmVoltageOn = 486,
  ScrHighTempFault = 487,
  ScrLoopOverCurrent = 488,
  ScrInsufficientArmatureCurrent = 489,
  ScrExcessiveArmatureCurrent = 490,
  ScrExcessiveCurrentCmdDriveEnabled = 491,
  ScrExcessiveCurrentCmdDriveDisabled = 492,
  InsufficientFieldVoltage = 493,
  FieldFailure = 494,
  SwingOperationActivated = 495,
  SwingOperationDeactivated = 496,
  FieldModuleOverTemperatureFault = 497,
  SpeedLimitMfForcing = 498,
  TachFailure = 499,
  SabbathOperationActivated = 500,
  SabbathOperationDeactivated = 501,
  RopeBrakeTripped = 502,
  RopeGripperLeg1ShortFault = 503,
  RopeGripperLeg2ShortFault = 504,
  AuxSpeedProfile1Activated = 505,
  AuxSpeedProfile1Deactivated = 506,
  AuxSpeedProfile2Activated = 507,
  AuxSpeedProfile2Deactivated = 508,
  MotorFieldForcingTimedOut = 509,
  IviewLoggedOn = 510,
  IviewLoggedOff = 511,
  IviewTimedOut = 512,
  IviewLostConnection = 513,
  BalancedMode = 514,
  LobbyPeakMode = 515,
  DemandUpPeakMode = 516,
  DemandDownPeakMode = 517,
  CfssMode1RecallActivated = 518,
  CfssMode1TransitionActivated = 519,
  CfssMode1InCarActivated = 520,
  CfssMode2RecallActivated = 521,
  CfssMode2TransitionActivated = 522,
  CfssMode2InCarActivated = 523,
  EmergencyAlarmAcknowledged = 524,
  EmergencyAlarmActivatedSafetyOpened = 525,
  EmergencyAlarmActivatedCarDelayed = 526,
  EmergencyAlarmActivatedAlarmButton = 527,
  EmergencyAlarmActivatedInCarStop = 528,
  RopeGripperOkFaulted = 529,
  CartopExitOpen = 530,
  SafetyCStringOpen = 531,
  MachineRoomStopSwitchOpen = 532,
  CarStopSwitchOpen = 533,
  ControllerStartup = 534,
  FloorSynchronizationFault = 535,
  TerminalSynchronizationFault = 536,
  PositionSynchronizationFault = 537,
  UpEmergencyTerminalSwitchShutdown = 538,
  DownEmergencyTerminalSwitchShutdown = 539,
  PowerUpPositionSyncRequired = 540,
  TerminalSwitchSpeedsNotLearned = 541,
  TerminalSwitchPositionsNotLearned = 542,
  ExcessiveMotorFieldVoltage = 543,
  BrakeOutputCircuitFailure = 544,
  GroupCommunicationEstablished = 545,
  FloodOperationActivated = 546,
  FloodOperationDeactivated = 547,
  RopeGripperUimResetButtonStuck = 548,
  ExerciseOperationActivated = 549,
  ExerciseOperationDeactivated = 550,
  ScrLowLineFault = 551,
  ScrLowLineCautionActivated = 552,
  ScrLowLineCautionDeactivated = 553,
  ScrLowLineTestFault = 554,
  ExcessiveRestartsWarning = 555,
  GovernorSpeedReductionSwitchFault = 556,
  SoftwareRecallCommandActivated = 557,
  ScrDriveReadyFault = 558,
  RetiringCamDoorLockFaultDeactivated = 559,
  RetiringCamProtectionFaultActivated = 560,
  RetiringCamProtectionFaultDeactivated = 561,
  WatchdogControlStopBeforeReset = 562,
  FrontHallDoorOpenButtonBypassed = 563,
  RearHallDoorOpenButtonBypassed = 564,
  FrontHallDoorOpenButtonFailure = 565,
  RearHallDoorOpenButtonFailure = 566,
  Bus2FuseOpen = 567,
  Bus2DFuseOpen = 568,
  Bus2McFuseOpen = 569,
  Bus2PiFuseOpen = 570,
  Bus3FuseOpen = 571,
  Bus3HaFuseOpen = 572,
  WatchdogEmergencyStopBeforeReset = 573,
  BackupDispatcherActivated = 574,
  BackupDispatcherDeactivated = 575,
  DriveStartFailure = 576,
  EmsMedicalRecallSwitch2 = 577,
  EmsMedicalInCarSwitch2 = 578,
  DoorsLockedFault = 579,
  EmergencyAlarmDeactivatedWithoutAck = 580,
  EMCPCPorDMShutdown = 581,
  DSDNotClosed = 582,
  ESTOpen = 583,
  CarGateOpenOutsideOfDoorZone = 584,
  DoorGateOpenOutsideOfDoorZone = 585,
  OilOverTemperatureHydrosOnly = 586
}
